<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnsendwln" @change="showUnsendwlnChange" active-text="万里牛未同步" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="星空未同步" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="flowimportreport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</el-main>
		</el-container>
		<edit-index ref="rowedit" :row="currentrow" @success="success" />	
		<importTable :ref="importRef"  />
		
		<!-- <edit-index ref="rowedit" :row="currentrow" @success="success" /> -->
<!-- 		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<receipt-index ref="receiptBox" :param="param" />
		<edit-index ref="rowedit" :row="currentrow" @success="success" />	
		<statistics-index ref="statistics" :transTime="transTime" @exportdetail="exportdetail" />	 -->
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;

	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import editIndex from './lib/edit/index.vue'
	import importTable from '@_system/components/import/index.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
		},
		data() {
			return {
				importRef: Math.random(),
				currentrow:null,
				showUnsendjindie:false,
				showUnsendwln:false,
				showtransferaccount:false,
				loading: false,
				reportName: 'reconciliation_bankflow',
				foreingKey:{},
				list_formConfig: [{
					field: 'cdSign',
					title: '收支方向',
					span: 4,
					resetValue:'-1',
					itemRender: {
						defaultValue:'-1',
						name: '$select',
						props:{							
							emptyoption:false,
							selectoptions:[{
								value:'-1',
								label:'全部'
							},{
								value:'0',
								label:'收入'
							},{
								value:'1',
								label:'支出'
							}]
						}
					}
				},{
					field: 'serialNo',
					title: '单据编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{
							
						}
					}
				},{
					field: 'voucherNo',
					title: '凭证号',
					span: 4,
					itemRender:{
						name:'$input'
					}
				},{
					field: 'transTime',
					title: '时间',
					span: 4,
					//resetValue:[this.$Moment().startOf('month').valueOf(),this.$Moment().endOf('month').valueOf()],
					itemRender: {
						//defaultValue:[this.$Moment().startOf('month').valueOf(),this.$Moment().endOf('month').valueOf()],
						name: '$datePicker'
					}
				}],					
				importfield:[]						
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			// list_init() {
			// 	this.$api.bankaccount.list({type:'wln'}).then((res)=>{
			// 		this.wlnbankoptions = res.list.map((item)=>{
			// 			return {
			// 				value:item.acc_code.toString(),
			// 				label:item.acc_name + '【'+(item.inst_account?item.inst_account:'马上填起来')+'】',
			// 				acc_uid:item.acc_uid,
			// 				inst_account:item.inst_account
			// 			}
			// 		})
			// 		this.list_formConfig.forEach((item)=>{
			// 			if(item.field == 'wlnbank'){
			// 				item.itemRender.props.selectoptions = this.wlnbankoptions
			// 			}
			// 		})
					
			// 		this.init_formButton()
			// 		let list_gridOptions = this.list_getOption()
			// 		this.list_beforeCreateGrid(list_gridOptions)
			// 		this.list_gridOptions = list_gridOptions

			// 	})			

			// },
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'importreport_list'
				gridOptions.toolbarConfig.buttons = [{
					name: '导入',
					status: 'danger',
					code: 'importflow'
				},{
					name: '同步万里牛',
					status: 'success',
					code: 'sendwln'
				},{
					name: '同步金蝶',
					status: 'danger',
					code: 'sendjindie'
				}]				
				gridOptions.columns = [
					{type:'checkbox',title:'#',fixed:'left',width:50},
						{field:'serialNo',title:'单据编码',render:'',props:{show:true},fixed:'left',width:'auto'},
						{field:'accName',title:'户名',render:'',props:{
							show:true,
						},width:'auto'},
						{field:'bankAcc',title:'账号',render:'',props:{show:true},width:'auto'},
						{
							field:'transTime',
							title:'时间',
							render:'$datePicker',
							props:{show:true},
							formatter:({cellValue})=>{
								return window.systemMethods.timestampToDate(cellValue)
							},
							width:'auto',
						},
						{field:'amt',title:'交易金额',render:'',props:{show:true},width:'auto'},
						{field:'oppAccName',title:'对方户名',render:'',props:{show:true},width:'auto'},
						{field:'oppAccNo',title:'对方账号',render:'',props:{show:true},width:'auto'},
						{field:'voucherNo',title:'凭证号',render:'',props:{show:true},fixed:'right',width:150},
						{field:'serialId',title:'流水ID',render:'',props:{show:true},fixed:'right',width:200},
						{field:'mark',title:'备注',render:'',props:{show:true},fixed:'right',width:100},					
						{field:'export_wln',title:'万里牛',render:'',props:{show:true},fixed:'right',width:100},
						{field:'export_jindie',title:'金蝶',render:'',props:{show:true},fixed:'right',width:100},
						{field:'export_jindie_type',title:'金蝶模块',render:'',props:{show:true},fixed:'right',width:100},
						{
							title: '操作',
							fixed: "right",
							align: 'center',
							width: 120,
							slots: {
								default: ({row}) => {
									return [
										<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
										<el-button type = "text" size = "mini" style="color:#F56C6C" onClick = {() => {this.del(row)}}>删除</el-button>
									]
								}
							}
						}
				]
				gridOptions.columns.forEach((item)=>{
					if(item.field=='serialNo'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.cdSign==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
								}
								if(row.cdSign==0){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
								}
								str.push(<span>{row.serialNo}</span>)
								return str
							}
						}
					}
					if(item.field=='export_wln'){
						item.slots = {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
					if(item.field=='export_jindie'){
						item.slots = {
							default:({row})=>{
								if(row.export_jindie_sucess!=1){
									if(row.export_jindie_error){
										return <span style="color:#F56C6C;">{row.export_jindie_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span style="color:#67C23A;">已同步</span> 	
								}
							}
						}
					}
				})
				gridOptions.pagerConfig.enabled = true
			},
			list(page,updateForm) {	
				return new Promise(resolve => {
					this.$api.report.reportlist(this.reportName,{
						...page,
						...updateForm,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						res.list.forEach((item)=>{
							return item.amount =  item.cdSign == 0 ? item.amount : -item.amount
						})
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			importflow(){
				this.$refs[this.importRef].importcomfig = this.importcomfig
				this.$refs[this.importRef].moduleImport = this.moduleImport
				this.$refs[this.importRef].importpanel()
			},
			importcomfig(){
				let res =[{
					id:1,
					code:'reconciliation_bankflow_import',
					config:'add',
					configtype:'custom',
					name:'交易流水导入',
					columns:[{
						config:['require'],
						field:'main|cdSign',
						name:'$select',
						props:{
							selectoptions:[{
								value:0,
								label:'收',
							},{
								value:1,
								label:'支',
							}]
						},
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'收支',
					},{
						config:['require'],
						field:'main|accName',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'户名',
					},{
						config:['require'],
						field:'main|bankAcc',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'账号',
					},{
						config:['require'],
						field:'main|transTime',
						name:'$datePicker',
						props:{
							type:'date'
						},
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'时间',
					},{
						config:['require'],
						field:'main|amt',
						name:'$inputNumber',
						props:{
							precision:2
						},
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'金额',
					},
					// {
					// 	config:[],
					// 	field:'main|oppAccName',
					// 	name:'$input',
					// 	props:[],
					// 	tablecode:'main',
					// 	tablecustomcode:'c_reconciliation_bankflow_import',
					// 	tablename:'主表',
					// 	tabletype:'main',
					// 	title:'对方户名',
					// },
					// {
					// 	config:[],
					// 	field:'main|oppAccNo',
					// 	name:'$input',
					// 	props:[],
					// 	tablecode:'main',
					// 	tablecustomcode:'c_reconciliation_bankflow_import',
					// 	tablename:'主表',
					// 	tabletype:'main',
					// 	title:'对方账号',
					// },
					{
						config:[],
						field:'main|voucherNo',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'凭证号',
					},
					{
						config:[],
						field:'main|uses',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'备注',
					}]
				},{
					id:2,
					code:'reconciliation_bankflow_update',
					config:'update',
					configtype:'custom',
					name:'交易流水导入',
					columns:[{
						config:['unique'],
						field:'main|serialId',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'流水ID',
					},{
						config:['require'],
						field:'main|cdSign',
						name:'$select',
						props:{
							selectoptions:[{
								value:0,
								label:'收',
							},{
								value:1,
								label:'支',
							}]
						},
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'收支',
					},{
						config:['require'],
						field:'main|accName',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'户名',
					},{
						config:['require'],
						field:'main|bankAcc',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'账号',
					},{
						config:['require'],
						field:'main|transTime',
						name:'$datePicker',
						props:{
							type:'date'
						},
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'时间',
					},{
						config:['require'],
						field:'main|amt',
						name:'$inputNumber',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'金额',
					},
					{
						config:[],
						field:'main|voucherNo',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'凭证号',
					},
					{
						config:[],
						field:'main|uses',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'备注',
					},{
						config:[],
						field:'main|uses',
						name:'$input',
						props:[],
						tablecode:'main',
						tablecustomcode:'c_reconciliation_bankflow_import',
						tablename:'主表',
						tabletype:'main',
						title:'备注',
					}]
				}]
				return Promise.resolve(res) 
			},
			moduleImport(formData) {
				return new Promise((reslove,reject)=>{
					this.$api[this.reportName].import(formData).then((res)=>{
						reslove(res)						
					},()=>{
						reject()
					})
				})				
			},
			
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},
			sendjindie(){
				let data =  this.$refs.flowimportreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendjindie({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			sendwln(){
				let data =  this.$refs.flowimportreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendwln({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})				
			},
			cellStyle({
				row
			}) {
				if (row.isreal == 0) {
					return {
						backgroundColor: 'rgb(244, 244, 245)'
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.flowimportreport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},
			edit(row){
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			del(row) {
				this.$confirm('是否确认删除 ' + (row.name ? row.name : ''), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.reconciliation_bankflow.delete(row.id).then(() => {
						this.customreload()
					})
				}).catch(() => {

				})
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.flowimportreport.commitProxy('query')
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.flowimportreport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			editIndex,
			importTable,
		}
	}
</script>